import Vue from "vue";
import Router from "vue-router";
import Schedule from "./views/Schedule.vue";
import Thumbs from "./views/Thumbs.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "schedule",
      component: Schedule
    },
    {
      path: "/thumbs",
      name: "thumbs",
      component: Thumbs
    },
    {
      path: "/schedule/:year",
      name: "schedule_year",
      component: Schedule
    },
    {
      path: "/thumbnails/:year",
      name: "thumbs_year",
      component: Thumbs
    }
  ]
});
